import { render, staticRenderFns } from "./cardGoPro.vue?vue&type=template&id=d81d23ae&scoped=true&"
import script from "./cardGoPro.vue?vue&type=script&lang=js&"
export * from "./cardGoPro.vue?vue&type=script&lang=js&"
import style0 from "./cardGoPro.vue?vue&type=style&index=0&id=d81d23ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81d23ae",
  null
  
)

export default component.exports